import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

import { motion } from 'framer-motion'

// Breakpoint visibility used to be JS-side (useResponsiveLayout), which is
// false for every branch at SSR — crawlers never saw the Clutch/Upwork
// badges. All variants render now; CSS decides. `display: contents` keeps
// the wrappers out of the flex layout, so the visible tree is unchanged.
// Thresholds mirror the hook: mobile <breakpoints.2 (md), tablet
// breakpoints.2–3, desktop ≥breakpoints.3 (lg).

export const DesktopOnly = styled.div`
  display: none;

  @media screen and (min-width: ${themeGet('breakpoints.3')}) {
    display: contents;
  }
`

export const MobileOnly = styled.div`
  display: contents;

  @media screen and (min-width: ${themeGet('breakpoints.2')}) {
    display: none;
  }
`

export const TabletOnly = styled.div`
  display: none;

  @media screen and (min-width: ${themeGet('breakpoints.2')}) {
    display: contents;
  }

  @media screen and (min-width: ${themeGet('breakpoints.3')}) {
    display: none;
  }
`

// Replicates the old JS-driven Row props: justifyCenter on mobile/desktop,
// spaceBetween while the tablet-only side badges are visible.
export const WidgetRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  @media screen and (min-width: ${themeGet('breakpoints.2')}) {
    justify-content: space-between;
  }

  @media screen and (min-width: ${themeGet('breakpoints.3')}) {
    justify-content: center;
  }
`

export const Content = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 24px;
  width: 100%;
  overflow: hidden;
`

export const PlayButton = styled(motion.button)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 12px;
  background-color: ${themeGet('colors.surface.block')};
  color: ${themeGet('colors.text.title')};

  > svg {
    width: 24px;
    height: 24px;
  }
`

export const PauseButton = styled(motion.button)`
  position: absolute;
  bottom: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  color: ${themeGet('colors.text.invertedMuted')};

  > svg {
    width: 24px;
    height: 24px;
  }
`

export const CoverHolder = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  > img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`
